import { Utils } from '../../app.base';
import { MsgBox, Vue } from '../../app.vues';
import SwbServicerListForDevice from './ServicerListForDevice';
Vue.regist(SwbServicerListForDevice);
import SwbServicerListForComn from './ServicerListForComn';
Vue.regist(SwbServicerListForComn);


//
export function openServicerListForDeviceDlg(devcId, devcDefId, devcGroupId, servcTypeId, retailerComId, item, callback) {
    let theDlg = Vue.$showDialog({
        title: "设备服务商",
        width: "90%",
        height: "90%",
        okVisible: false,
        showCloseBtn: false,
        cancelText: '关闭',
        template: '<div>' +
        '<swb-spec-servicer-list-for-device :devcId="devcId"  :devcDefId="devcDefId" :devcGroupId="devcGroupId" :servcTypeId="servcTypeId" :item="item" :retailerComId="retailerComId" ref="swb_spec_servicer_list_for_device"></swb-spec-servicer-list-for-device>' +
        '</div>',
        data: {
            devcId: devcId,
            devcDefId: devcDefId,
            devcGroupId: devcGroupId,
            servcTypeId: servcTypeId,
            retailerComId: retailerComId,
            item: item
        },
        methods: {
            theDlgClose: function () {
                if(typeof callback == 'function') {
                    callback();
                }
                theDlg.close();
            }
        }
    });
};

//
export function openServicerListForComnDlg(repairId, requireId, retailerComId, servcTypeId, item) {
    let theDlg = Vue.$showDialog({
        title: "常规项目服务商",
        width: "90%",
        height: "90%",
        okVisible: false,
        showCloseBtn: true,
        cancelText: '关闭',
        template: '<div>' +
        '<swb-spec-servicer-list-for-comn :repairId="repairId" :requireId="requireId"  :retailerComId="retailerComId" :servcTypeId="servcTypeId" :item="item" ref="swb_spec_servicer_list_for_device"></swb-spec-servicer-list-for-comn>' +
        '</div>',
        data: {
            repairId : repairId,
            requireId: requireId,
            retailerComId: retailerComId,
            servcTypeId: servcTypeId,
            item: item
        },
        methods: {
            theDlgClose: function () {
                theDlg.close();
            }
        }
    });
};





//////////////////
// WEBPACK FOOTER
// ./src/compo/spec/selectDlg.js
// module id = 151
// module chunks = 0